import { defineStore } from 'pinia'
import api from '../services/api'

export const useUserStore = defineStore('user', {
  state: () => ({
    fullName: '',
    username: '',
    email: '',
    memberSince: '',
    phone: '',
    avatar: '',
    clientNumber: '',
  }),

  actions: {
    async fetchUser() {
      try {
        const response = await api.getMyInfo()
        const userData = response.data.data

        const createdAt = userData.created_at
        const date = createdAt ? new Date(createdAt) : null
        const formattedDate = date
          ? `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(
              2,
              '0',
            )}/${date.getFullYear()}`
          : ''

        this.fullName = userData.full_name
        this.username = userData.username
        this.email = userData.email
        this.memberSince = formattedDate
        this.phone = userData.phone
        this.avatar = userData.avatar?.main || ''
        this.clientNumber = userData.clientNumber
      } catch (error: unknown) {
        let message = 'Failed to load user information'
        if (error instanceof Error && 'response' in error) {
          const axiosError = error as { response?: { data?: { message?: string } } }
          message = axiosError.response?.data?.message || message
        }
        console.error(message)
        throw error
      }
    },

    clearUser() {
      this.$reset()
    },
  },
})
